export const Footer = () => {}
